import { ceil } from 'lodash';

export default function roundBetByStep(bet: number, step: number) {
    const roundedBet = ceil(bet);

    return roundedBet + step - (roundedBet % step);
}
